import isEqual from 'lodash/isEqual';
import clone from 'lodash/clone';

/** Internal dependencies */
import { NCST } from '../';

export class ControllerComponent {
	constructor() {
		this.state = {};
		this.prevState = clone( this.state );
	}

	setState( object ) {
		for ( var key in object ) {
			if ( this.state.hasOwnProperty( key ) ) {
				this.state[ key ] = object[ key ];
			}
		}

		if ( ! isEqual( this.state, this.prevState ) ) {
			this.prevState = clone( this.state );
			NCST.requestAnimationFrame( this.render.bind( this ) );
		}
	}
}
